import { getRequest } from './request';

export const getEnabledFeatures = async () => {
  const response = await getRequest<string>(`/features`, {});
  return response.body.data as string[];
};
